import _styled from "@emotion/styled/base";
const Card = /*#__PURE__*/_styled("div", {
  target: "e4i6gfb0",
  label: "Card"
})("background-color:", ({
  theme
}) => theme.color.elevatedSurface, ";", ({
  rounded
}) => rounded ? `border-radius: ${rounded === 'sm' ? 2 : rounded === 'lg' ? 6 : 4}px` : ``, ";", ({
  theme,
  direction,
  elevation
}) => elevation && `box-shadow: ${theme.shadow({
  direction,
  size: elevation && typeof elevation === 'string' ? elevation : 'xs',
  theme
})}
    `, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9DYXJkL0NhcmQuanN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUV1QiIsImZpbGUiOiIuLi8uLi8uLi9zcmMvQ2FyZC9DYXJkLmpzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuY29uc3QgQ2FyZCA9IHN0eWxlZC5kaXZgXG4gIGJhY2tncm91bmQtY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29sb3IuZWxldmF0ZWRTdXJmYWNlfTtcbiAgJHsoeyByb3VuZGVkIH0pID0+XG4gICAgcm91bmRlZCA/IGBib3JkZXItcmFkaXVzOiAke3JvdW5kZWQgPT09ICdzbScgPyAyIDogcm91bmRlZCA9PT0gJ2xnJyA/IDYgOiA0fXB4YCA6IGBgfTtcbiAgJHsoeyB0aGVtZSwgZGlyZWN0aW9uLCBlbGV2YXRpb24gfSkgPT5cbiAgICBlbGV2YXRpb24gJiZcbiAgICBgYm94LXNoYWRvdzogJHt0aGVtZS5zaGFkb3coe1xuICAgICAgZGlyZWN0aW9uLFxuICAgICAgc2l6ZTogZWxldmF0aW9uICYmIHR5cGVvZiBlbGV2YXRpb24gPT09ICdzdHJpbmcnID8gZWxldmF0aW9uIDogJ3hzJyxcbiAgICAgIHRoZW1lLFxuICAgIH0pfVxuICAgIGB9O1xuYDtcblxuQ2FyZC5kZWZhdWx0UHJvcHMgPSB7IGRpcmVjdGlvbjogJ2Rvd24nLCByb3VuZGVkOiAnbGcnIH07XG5cbmV4cG9ydCBkZWZhdWx0IENhcmQ7XG4iXX0= */"));
Card.defaultProps = {
  direction: 'down',
  rounded: 'lg'
};
export default Card;